<div *ngIf='sessionData && dataReady' class='ViewMessage container'>
  <div
    class='ViewMessage__header d-flex flex-row align-items-center justify-content-between mb-3 mb-sm-0'>
    <h2 class='ViewMessage__title'>Meeting details</h2>
    <div *ngIf='!isMobile; else mobileMenuTop' class='meeting-controls d-flex flex-row justify-content-end'>
      <app-button
        [Click]='backToOpp.bind(this)'
        [color]="'white'"
        [text]="'Back'"></app-button>
      <app-button
        [Click]='editMeeting.bind(this)'
        [color]="'orange'"
        [text]="'Edit'"></app-button>
      <app-button
        *ngIf='sessionData.user_type === userTypes.SINGLE_USER'
        [Click]='deleteMeeting.bind(this)'
        [color]="'red'"
        [text]="'Delete'"></app-button>
      <app-button-select
        *ngIf='exportButtonSelect && exportButtonSelect.buttonProperties'
        [buttonProperties]='exportButtonSelect.buttonProperties'
        [items]='exportButtonSelect.items'></app-button-select>
    </div>
    <ng-template #mobileMenuTop>
      <app-menu-button [properties]='menuItemsTop'
                       [target]='this'></app-menu-button>
    </ng-template>
  </div>
  <div *ngIf='isMobile' class='mb-3'>
    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>Conversation</mat-panel-title>
        </mat-expansion-panel-header>
        <ng-container *ngIf='messages && messages.length > 0'>
          <div class='view-msg-campaign'>
            <app-message-viewer
              *ngFor='let message of messages'
              [asPlainText]='viewAsPlain'
              [message]='message'
              [sessionData]='sessionData'></app-message-viewer>
          </div>
        </ng-container>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
  <div class='details'>
    <ul>
      <li><b>Name:</b> {{ meetingData.contact_name }}</li>
      <li><b>Company:</b> {{ meetingData.contact_company }}</li>
      <li><b>Primary email:</b> {{ meetingData.contact_email }}</li>
      <li><b>Primary phone number:</b> {{ meetingData.contact_phone }}</li>
      <li>
        <b>Meeting date:</b>
        {{
          meetingData.meeting_date
            | timezone: 'MM/DD/YYYY hh:mm a'
        }}
      </li>
      <li><b>Current reply action:</b> {{ meetingData.reply_action }}</li>
      <li
        *ngIf="
          meetingData.next_email !== 'No Email Scheduled';
          else noNextEmail
        ">
        <b>Next email date:</b>
        {{
          meetingData.next_email | timezone: 'MM/DD/YY' : sessionData.time_zone
        }}
      </li>
      <ng-template #noNextEmail>
        <li><b>Next email date:</b> {{ meetingData.next_email }}</li>
      </ng-template>
      <li><b>Notes:</b> {{ meetingData.meeting_notes }}</li>
    </ul>
  </div>


  <div class='d-flex flex-column flex-sm-row justify-content-between align-items-center my-5'>
    <h4 class='ViewMessage__title'>Associated contacts</h4>
    <h4 *ngIf='getMessageCampaing()' class='ViewMessage__title'>
      <b>Camping: </b>{{ getMessageCampaing() }}
    </h4>
    <app-button-select
      *ngIf="
        (sessionData.user_type === 'user' || sessionData.user_type === 'user') &&
        responseButtonSelect &&
        responseButtonSelect.buttonProperties
      "
      [buttonProperties]='responseButtonSelect.buttonProperties'
      [items]='responseButtonSelect.items'></app-button-select>
  </div>
  <div class='d-flex flex-row justify-content-between align-items-center mb-3'>
    <h4 class='ViewMessage__title'>Associated products</h4>
    <ng-container *ngIf='!isMobile; else mobileMenuProduct'>
      <app-button
        (click)='add()'
        *ngIf='sessionData.user_type !== userTypes.MASTER'
        [color]="'orange'"
        [size]="'small'"
        [text]="'Add New Product'"></app-button>
    </ng-container>
    <ng-template #mobileMenuProduct>
      <app-menu-button [properties]='menuItemsProducts'
                       [target]='this'></app-menu-button>
    </ng-template>
  </div>
  <app-table #tableComponent *ngIf='associatedTableReady' [columns]='assosiatedProductsTableColumns'
             [dataSourceParams]='associatedDataSourceParams' [dataSource]='associatedDataSource'>
    <ng-template [appTableMobileRow] let-currentUser='currentUser' let-row='row'>
      <app-associated-products-mobile-row (delete)='deleteProduct($event)' (update)='update($event)' [currentUser]='
currentUser' [item]='row'></app-associated-products-mobile-row>
    </ng-template>
  </app-table>
  <ng-container *ngIf='messages && messages.length > 0 && !isMobile'>
    <div class='view-msg-campaign mt-5'>
      <app-message-viewer
        *ngFor='let message of messages'
        [asPlainText]='viewAsPlain'
        [message]='message'
        [sessionData]='sessionData'></app-message-viewer>
    </div>
  </ng-container>
</div>
